export default __webpack_public_path__ + "assets/icon-receipt-green.a096e7c2.webp";